import { UNIT_FT, UNIT_INCH, UNIT_KG, UNIT_SQFT } from "./constants/index.js";

export default function (unit) {
  return [UNIT_FT, UNIT_KG, UNIT_SQFT, UNIT_INCH].indexOf(unit) >= 0;
}
